import React, { useState, useEffect, forwardRef, useImperativeHandle, useRef } from 'react';
import {
    Breadcrumb,
    Dropdown,
    Flex,
    Row,
    Col,
    theme,
    FloatButton,
    Form,
    Input,
    Button,
    Image,
    Upload,
    Divider,
    DatePicker,
    Tooltip,
    Checkbox,
    Radio,
    message
} from 'antd';
import {
    HomeOutlined,
    FontSizeOutlined,
    AlignLeftOutlined,
    PlusOutlined,
    PictureOutlined,
    BorderVerticleOutlined,
    DeleteOutlined,
    HolderOutlined,
    BorderOutlined,
    CalendarOutlined,
    PicLeftOutlined,
    CheckSquareOutlined,
    CheckCircleOutlined,
    HighlightOutlined
} from '@ant-design/icons';
import { DndContext, closestCenter,PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import ReactDOMServer from 'react-dom/server';
import { arrayMove, SortableContext, useSortable, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import TextEditor from '../TextEditor';
import { useSelector } from 'react-redux';
import RequestApproval from '../../restAPI/RequestApproval';
import dayjs from "dayjs";
//import getdropcontent from './dropcontentFunction';

const items = [
    { key: '1', label: 'Row With 1 Column' },
    { key: '2', label: 'Row With 2 Columns' },
    { key: '3', label: 'Row With 3 Columns' },
];

const getBase64 = (file) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });

const Templates = forwardRef(({ drawerclose, initialData, creationType }, ref) => {
    const { companyId, token, userCompany, role } = useSelector(state => state.auth);
    const {
        token: { colorBgContainer, borderRadiusLG, colorBorder },
    } = theme.useToken();


    const templateContentRef = useRef([])
    const [forceRender, setForceRender] = useState(0);
    const [ChangedValue,setChangedValue] = useState();
    const [rows, setRows] = useState([]);
    const [renderstate, setRenderstate] = useState(0);
    const [hoveredRowId, setHoveredRowId] = useState(null);
    const [droppedContent, setDroppedContent] = useState({});
    const [form] = Form.useForm();
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const [fileList, setFileList] = useState([]);
    const [templateName, settemplateName] = useState("");
    const [templateId, setTemplateId] = useState("");
    const [count, setCount] = useState(0);
    const [formData, setFormData] = useState({})
    const [initialvalues, setInitialvalues] = useState()
    const [focusedField,setFocusedField] = useState(null);


    const [files, setFiles] = useState([])

    const inputRefs = useRef({});

    RequestApproval.testWithJWTandCID(companyId, token);

    useEffect(() => {
        // let k = JSON.stringify(rows);
        console.log("Current Updated files state:", fileList);
        // This runs whenever `data` changes
    }, [fileList]);

    useEffect(() => {
        let k = JSON.stringify(rows);
        console.log("Current Updated State:", rows);
        console.log(initialvalues, "ddddddddddddddddddddddddd") // This runs whenever `data` changes
        console.log(templateContentRef.current,"handleMenuClick templateContent");
    }, [rows]);

    useEffect(()=>{
        if (focusedField!==null) {
            console.log(inputRefs.current[focusedField],"   vvvvvxxxxxxxxxx  ",focusedField)
            inputRefs.current[focusedField].focus()
            // setTimeout(() => inputRefs.current[focusedField].focus(), 0.0001);
          }
          console.log(templateContentRef.current,"templateContentRef.currenta updated")
    },[forceRender])

    const initialValues = {};
    if (initialData !== null) {
        const valll = JSON.parse(initialData.templateContent);
        console.log(valll,"zzyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyy")
        if(creationType=="edit"){
            initialValues["templatename"]=initialData.name
        }
        valll.forEach((item) => {
            item.fields.forEach((field) => {
                let name = field.cellId.replace("-", "");
                initialValues[`label${name}`] = field.label;
                if(field.content=="DateField"){
                    initialValues[`value${name}`] = dayjs(field.value);
                }else{
                    initialValues[`value${name}`] = field.value;
                }
                

            });
        });
    }

    useEffect(() => {
        if (initialData != null) {
            console.log(initialData,"initialData make a copy xxxxxxxxxxxxxxxxxxxxxxxxx")
            let valued = JSON.parse(initialData.templateContent);
            let count = valued.length
            setCount(count);
            updateFileList(valued);
            if(creationType=="edit"){
                console.log(creationType)
                console.log(initialData.name)
                console.log(initialData._id)
                settemplateName(initialData.name);
                setTemplateId(initialData._id);
            }
            // setRows(valued);
            templateContentRef.current=valued;
            console.log(templateContentRef.current,"templateContentRef.currenta copy xxxxxxxxxxxxxxxxxxxxxxxxx")

        }

    }, []);
    const updateFileList = (jsonObject) => {
        let filearray = []
        jsonObject.forEach((record) => {
            if (record.fields.length > 0) {
                record.fields.forEach((field) => {
                    let cellId = field.cellId;
                    if (field.filelist.length > 0) {
                        let subarray = []
                        field.filelist.forEach((file, index) => {
                            let filename = `image-${index}`
                            const tempfile = base64ToImageFile(file.image, filename)
                            const obj = {
                                uid: new Date().getTime().toString(), // Unique ID
                                name: filename,
                                status: "done",
                                thumbUrl: file.image,
                                originFileObj: tempfile
                            }
                            // console.log(obj,"image indexxxxx")
                            subarray.push(obj);

                        })
                        filearray[cellId] = subarray;
                    }
                })
            }
        })
        setFileList(filearray);
        // console.log(filearray,"fifififile aarrraay")
        // const base64Image = "data:image/png;base64,iVBORw0KGgo...";
        // const file = base64ToImageFile(base64Image, "image.png");
    }

    const base64ToImageFile = (base64String, fileName) => {
        const arr = base64String.split(",");
        const mime = arr[0].match(/:(.*?);/)[1];
        const byteString = atob(arr[1]); // Decode Base64
        const byteArray = new Uint8Array(byteString.length);

        for (let i = 0; i < byteString.length; i++) {
            byteArray[i] = byteString.charCodeAt(i);
        }

        return new File([byteArray], fileName, { type: mime });
    }
    useImperativeHandle(ref, () => ({
        async validateAndSaveTemplate() {

            try {
                // Validate specific fields
                await form.validateFields(['templatename']);

                if (templateContentRef.current.length < 1) {
                    message.warning('Template Should Have At Least One Row');
                    throw new Error("rows less than 1");
                }
                else {
                    console.log(templateContentRef.current, "templateContentRef.current");
                    console.log(droppedContent, "droppedContent");

                    for (const row of templateContentRef.current) {
                        console.log(row, "row of forOf loop");
                        for (const field of row.fields) {
                            let name = field.cellId.replace("-", "");
                            console.log(field, "field of forOf loop");
                            await form.validateFields([`label${name}`]);
                        }
                    }

                    // for(let i=0; i<rows.length; i++){

                    //     //console.log(i, "iiiiiiiii");
                    //     //console.log(rows[i], "row");

                    //     let type = rows[i].type;
                    //     let id = rows[i].id;
                    //     let regex = new RegExp(`^(${id})-`);
                    //     const filteredObj = Object.fromEntries(
                    //         Object.entries(droppedContent).filter(([key, value]) => regex.test(key))
                    //       );
                    //     //console.log(filteredObj, "filteredObj");
                    //     //console.log(type, "type");
                    //     if(Object.keys(filteredObj).length!=type){
                    //         console.log(Object.keys(filteredObj).length,"length");
                    //         console.log(type,"type");

                    //         console.log(rows,"rows");
                    //         console.log(droppedContent,"droppedContent");
                    //         message.warning(`Template Should Have Fill All Collumns`);
                    //         throw new Error("Content not filled");
                    //     }
                    // }
                }

                // if(Object.keys(droppedContent).length==0){
                //     message.warning('Template Should Have Some Content');
                //     throw new Error("droppedContent empty");
                // }
                //let smplestr = `[{"id":1,"type":"1","fields":[{"content":"ImageUploader","cellId":"1-0","label":"ff","value":"","options":[{"id":"0","value":"","disabled":true},{"id":"1","value":"","disabled":true},{"id":"2","value":"","disabled":true}],"filelist":[{"id":0,"image":"data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/4gIoSUNDX1BST0ZJTEUAAQEAAAIYAAAAAAIQAABtbnRyUkdCIFhZWiAAAAAAAAAAAAAAAABhY3NwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAA9tYAAQAAAADTLQAAAAAAAAAAAAAAAAAAAAVvb5K37Mer7u0","uid":"__AUTO__1738212739735_0__"}]}]}]`
                let templateJsonString = JSON.stringify(templateContentRef.current);
                // console.log(templateJsonString,"templateJsonString");
                

                if(creationType=="edit"){
                    const obj = {
                        name: templateName,
                        templateContent: templateJsonString
                    }
                    const data = RequestApproval.editTemplate(obj,templateId)
                    .then((response) => {

                        message.success('Update Template Successfully!');

                    })
                    .catch((err) => {
                        if (err.response) {
                            message.error(`${err.response.data.message}`);
                        } else {
                            message.error('Update Template Faild!');
                        }
                    });
                }
                else{
                    const obj = {
                        name: templateName,
                        templateContent: templateJsonString,
                        status: true
                    }
                    const data = RequestApproval.createTemplate(obj)
                    .then((response) => {

                        message.success('Template Created Successfully!!');

                    })
                    .catch((err) => {
                        if (err.response) {
                            message.error(`${err.response.data.message}`);
                        } else {
                            message.error('Creation Faild!');
                        }
                    });
                }
                

                drawerclose();

                return true;

            } catch (errorInfo) {
                console.error('Validation Failed:', errorInfo);
                return false;
            }
        },

        clearTemplateState() {
            try {
                console.log('hhhhhhhhhhhhhhhhh');
                settemplateName("");
                // setRows([]);
                templateContentRef.current=[]
                setDroppedContent({});
                setCount(0);
                setFileList([]);
                form.resetFields();

            }
            catch (error) {
                console.log("clearTemplateState error :", error);
            }
        }
    }

    ));

    const handleMenuClick = ({ key }) => {

        console.log(rows.length + 1, "row length");
        console.log(key, "keeeeey");

        // setRows((prevRows) => [
        //     ...prevRows,
        //     { id: count, type: key, fields: [] },
        // ]);

        templateContentRef.current.push({ id: count, type: key, fields: [] })

        const columnCount = key === '1' ? 1 : key === '2' ? 2 : 3;
        // const span = 24 / columnCount;

        // for (let i = 0; i < columnCount; i++) {
        //     const cellId = `${count}-${i}`;

        //     setFormData((prevState) => ({
        //         ...prevState, // Spread the existing state
        //         [cellId]: "", // Add the new attribute with a value
        //     }));
        // }

        setCount(count + 1);
        setForceRender(forceRender+1);
        console.log("handleMenuClick");
        

    };

    const style = {
        filterStyle: {
            border: `1px dashed ${colorBorder}`,
            padding: 4,
            minHeight: 60,
            position: 'relative',
        },
    };

    const handleDragStart = (event, content) => {
        event.dataTransfer.setData('text/plain', content);
    };

    const handleDrop = (event, cellId, row) => {
        event.preventDefault();
        const content = event.dataTransfer.getData('text/plain');


        // setDroppedContent((prevContent) => ({
        //     ...prevContent,
        //     [cellId]: getdropcontent(content,cellId,row)
        // }));

        let dropedObject = {
            "content": content,
            "cellId": cellId,
            "label": "",
            "value": "",
            "options": [
                {
                    "id": "0",
                    "value": "",
                    "disabled": true
                },
                {
                    "id": "1",
                    "value": "",
                    "disabled": true
                },
                {
                    "id": "2",
                    "value": "",
                    "disabled": true
                }
            ],
            "filelist": [],
        }

        //let fields = {...rows};

        //fields
        //console.log(rows,"ddddddddddddddddddddd");
        // let currentstate = [...rows]
        // currentstate.forEach((rowitem, index) => {
        //     if (rowitem.id === row) {
        //         let valu = rowitem.fields.filter(val => val.cellId !== cellId);
        //         rowitem.fields = valu
        //     }
        // })
        // let setted = currentstate.map((item) =>
        //     item.id === row
        //         ? {
        //             ...item,
        //             fields: [...(item.fields || []), dropedObject],
        //         }
        //         : item
        // );

        let currentstateref = templateContentRef.current
        currentstateref.forEach((rowitem, index) => {
            if (rowitem.id === row) {
                let valu = rowitem.fields.filter(val => val.cellId !== cellId);
                rowitem.fields = valu
            }
        })
        let settedref = currentstateref.map((item) =>
            item.id === row
                ? {
                    ...item,
                    fields: [...(item.fields || []), dropedObject],
                }
                : item
        );

        //console.log(ggg,"fhhfffhhfhfhfhf")
        // setRows(setted);
        
        templateContentRef.current=settedref
        setForceRender(forceRender+1);
        let name = cellId.replace("-", "");
        let labelname = `label${name}`
        let valuename = `value${name}`
        form.setFieldsValue({ [labelname]: undefined, [valuename]:undefined});

        console.log("droppedContent");

    };

    const getdropcontent = (item, row) => {
        //console.log(item.value,"item.value")
        // let valueit = item.value
        // console.log(valueit,"item.value")
        // let labelit = item.label
        // console.log(labelit,"item.label")
        let name = item.cellId.replace("-", "");
        let labelname = `label${name}`
        let valuename = `value${name}`
        let dropcontent = <></>

        dropcontent = (item.content === 'TextEditor') ? (
            <>
                <React.Fragment key={item.cellId}>
                    <Form.Item style={{marginLeft:'10px',marginRight:'10px'}} name={`label${name}`} rules={[{ required: true, message: 'Please add label' }]}>
                        <Input value={item.label} placeholder='Enter Description for the Textarea' onChange={(e) => { onChangeInputLabel(e, item.cellId, row); }} />
                    </Form.Item>
                    <TextEditor name={`value${name}`} onchangefunction={onChangeInputValue} item={item} row={row} focusedField={focusedField} inputRef={inputRefs}/>
                </React.Fragment>
            </>

        ) : (item.content === 'Title') ? (
            <>
                <Form.Item style={{marginLeft:'10px',marginRight:'10px'}} name={`label${name}`} rules={[{ required: true, message: 'Please add label' }]}>
                    <Input  value={item.label} placeholder='Enter Description for the Title' onChange={(e) => { onChangeInputLabel(e, item.cellId, row) }} />
                </Form.Item>

                <Form.Item name={`value${name}`} style={{ margin: 10 }} >
                    <Input  name={`${item.cellId}`} value={item.value} onChange={(e) => { onChangeInputValue(e, item.cellId, row) }} placeholder="Enter title here" />
                </Form.Item>
            </>
        ) : item.content === 'DateField' ? (
            <>
                <Form.Item style={{marginLeft:'10px',marginRight:'10px'}} name={`label${name}`} rules={[{ required: true, message: 'Please add label' }]}>
                    <Input  value={item.label} placeholder='Enter Description for the Date' onChange={(e) => { onChangeInputLabel(e, item.cellId, row) }} />
                </Form.Item>
                <Form.Item name={`value${name}`} style={{ margin: 10 }}>
                    <DatePicker value={item.value} onChange={(date, dateString) => { handleDateChange(date, dateString, item.cellId, row) }} />
                </Form.Item>
            </>
        ) : item.content === 'ImageUploader' ? (
            renderImageUploader(item, row)

        ) : item.content === 'Signature' ? (
            renderImageUploader(item, row)
        ) : item.content === 'Divider' ? (
            <Divider />
        ) : item.content === 'CheckGroup' ? (
            <>
                <Form.Item style={{marginLeft:'10px',marginRight:'10px'}} name={`label${name}`} rules={[{ required: true, message: 'Please add label' }]}>
                    <Input  value={item.label} placeholder='Enter Description for the Select CheckGroup' onChange={(e) => { onChangeInputLabel(e, item.cellId, row) }} />
                </Form.Item>
                <Form.Item style={{ margin: 12 }}>
                    <Checkbox.Group name={`value${name}`} onChange={(e) => onChangeCheckBoxes(e, item.cellId, row)} value={item.value} style={{ width: '100%' }}>
                        {item.options.map((option,index) => (
                            <Flex align='center' gap={16} justify='flex-start' style={{ marginBottom: 8, width: '100%' }}>
                                <Checkbox disabled={option.disabled} key={option.id} value={option.id} /> <Input ref={(el) => (inputRefs.current[`value${name}${index}`] = el)} key={`value${name}${index}`} value={option.value} onChange={(e) => { onChangeRadioInput(e, item.cellId, row, option.id,index) }} />
                            </Flex>
                        ))}
                    </Checkbox.Group>
                    <Flex align='center' justify='flex-end'>
                        <Button onClick={() => { addNewOption(item, row) }}>Add New</Button>
                    </Flex>
                </Form.Item>
            </>

        ) : item.content === 'RadioGroup' ? (
            <>
                <Form.Item style={{marginLeft:'10px',marginRight:'10px'}} name={`label${name}`} rules={[{ required: true, message: 'Please add label' }]}>
                    <Input  value={item.label} placeholder='Enter Description for the RadioGroup' onChange={(e) => { onChangeInputLabel(e, item.cellId, row) }} />
                </Form.Item>
                <Form.Item style={{ margin: 12 }}>
                    <Radio.Group name={`value${name}`} style={{ width: '100%' }} onChange={(e) => { onchangeRadioGroup(e, item.cellId, row) }} value={item.value}>
                        {item.options.map((option,index) => (
                            <Flex align='center' gap={16} justify='flex-start' style={{ marginBottom: 8 }}>
                                <Radio disabled={option.disabled} key={option.id} value={option.id} /> <Input ref={(el) => (inputRefs.current[`value${name}${index}`] = el)} key={`value${name}${index}`}  value={option.value} onChange={(e) => { onChangeRadioInput(e, item.cellId, row, option.id,index) }} />
                            </Flex>
                        ))}
                    </Radio.Group>
                    <Flex align='center' justify='flex-end'>
                        <Button onClick={() => { addNewOption(item, row) }}>Add New</Button>
                    </Flex>
                </Form.Item>
            </>
        ) : item.content === 'SelectGroup' ? (
            <>
                <Form.Item style={{marginLeft:'10px',marginRight:'10px'}} name={`label${name}`} rules={[{ required: true, message: 'Please add label' }]}>
                    <Input ref={(el) => (inputRefs.current[`label${name}`] = el)} value={item.label} placeholder='Enter Description for the Select Options' onChange={(e) => { onChangeInputLabel(e, item.cellId, row) }} />
                </Form.Item>
                <Form.Item style={{ margin: 12 }}>
                    <Radio.Group style={{ width: '100%' }}>
                        {item.options.map((option,index) => (
                            <Flex align='center' gap={16} justify='flex-start' style={{ marginBottom: 8 }}>
                                <Input name={`value${name}${index}`} ref={(el) => (inputRefs.current[`value${name}${index}`] = el)} value={option.value} onChange={(e) => { onChangeRadioInput(e, item.cellId, row, option.id,index) }} />
                            </Flex>
                        ))}
                    </Radio.Group>
                    <Flex align='center' justify='flex-end'>
                        <Button onClick={() => { addNewOption(item, row) }}>Add New</Button>
                    </Flex>
                </Form.Item>
            </>
        ) : null


        return dropcontent;

    }

    const onChangeCheckBoxes = (checkedValues, cellId, row) => {
        // console.log("Checked values:", checkedValues);
        let str = JSON.stringify(checkedValues);
        let obj = {
            target: {
                value: checkedValues
            }
        }
        onChangeInputValue(obj, cellId, row);
        setForceRender(forceRender+1);
        // console.log(str);
    };
    const onchangeRadioGroup=(e, cellId, row)=>{
        onChangeInputValue(e, cellId, row)
        setForceRender(forceRender+1);
    }

    const onChangeInputLabel = (e, cellId, row) => {
        
        let currentstate = templateContentRef.current
        console.log(currentstate, "jjjjjjjjjjjj")
        let edited = currentstate.map((item) =>
            item.id === row
                ? {
                    ...item,
                    //fields: [...(item.nestedList || []), dropedObject],
                    fields: item.fields.map((nestedItem) =>
                        nestedItem.cellId === cellId
                            ? { ...nestedItem, label: e.target.value } // Update the nested item's value
                            : nestedItem
                    )
                }
                : item)
        // setRows(edited)
        templateContentRef.current=edited
        // let name = cellId.replace("-", "");
        // let labelname = `label${name}`
        // setFocusedField(labelname);
        // console.log(labelname,'chaned label   helllllllllow');
        // form.setFieldsValue({ [labelname]: e.target.value });

        // if (inputRefs.current[labelname]) {
        //     console.log('helllllllllow');
        //     inputRefs.current[labelname].focus();
        // }

    }

    const onChangeInputValue = (e, cellId, row) => {

        let currentstate = templateContentRef.current

        let edited = currentstate.map((item) =>
            item.id === row
                ? {
                    ...item,
                    //fields: [...(item.nestedList || []), dropedObject],
                    fields: item.fields.map((nestedItem) =>
                        nestedItem.cellId === cellId
                            ? { ...nestedItem, value: e.target.value } // Update the nested item's value
                            : nestedItem
                    )
                }
                : item)

        templateContentRef.current=edited
        // console.log(edited,"edite refssss")
        // let name = cellId.replace("-", "");
        // let valuename = `value${name}`
        // setFocusedField(valuename);
        // if (inputRefs.current[cellId]) {
        //     inputRefs.current[cellId].focus();
        // }
    }
    const handleDateChange = (date, dateString, cellId, row) => {
        // `date` is a Day.js object
        // `dateString` is the formatted date as a string
        console.log(date, "date")
        console.log(dateString, "date string")

        let obj = {
            target: {
                value: dateString
            }
        }
        onChangeInputValue(obj, cellId, row)
        // setFormData((prevState) => ({
        //     ...prevState, // Spread the existing state
        //     [cellId]: date // Add the new attribute with a value
        // }));
    };

    const onChangeRadioInput = (e, cellId, row, optionId,index) => {
        console.log("ddqqqqqqqqqqqqqqqqqqqqqqqqqq")
        let currentstate = templateContentRef.current
        console.log(currentstate,"ddqqqqqqqqqqqqqqqqqqqqqqqqqq")
        let edited = currentstate.map((item) =>
            item.id === row
                ? {
                    ...item,
                    //fields: [...(item.nestedList || []), dropedObject],
                    fields: item.fields.map((nestedItem) =>
                        nestedItem.cellId === cellId
                            ? {
                                ...nestedItem,
                                options: nestedItem.options.map((option) =>
                                    option.id === optionId
                                        ? { ...option, value: e.target.value, disabled: false }
                                        : option
                                )

                            } // Update the nested item's value
                            : nestedItem
                    )
                }
                : item)
        console.log(edited,"ddqqqqqqqqqqwwwwwwwwwwwwwwwwwwwwwwwwwqqqqqqqqqqqqqqqq")
        // setRows(edited);
        // setRenderstate(renderstate+1);
        templateContentRef.current=edited
        let name = cellId.replace("-", "");
        let valuename = `value${name}${index}`
        setFocusedField(valuename);
        setForceRender(forceRender+1);
    }

    const addNewOption = (itemk, row) => {

        let option = {
            "id": `${itemk.options.length}`,
            "value": "",
            "disabled": true
        }
        let currentstate = templateContentRef.current

        let edited = currentstate.map((item) =>
            item.id === row
                ? {
                    ...item,
                    //fields: [...(item.nestedList || []), dropedObject],
                    fields: item.fields.map((nestedItem) =>
                        nestedItem.cellId === itemk.cellId
                            ? {
                                ...nestedItem,
                                options: [...nestedItem.options, option]

                            } // Update the nested item's value
                            : nestedItem
                    )
                }
                : item)

        // setRows(edited);
        templateContentRef.current=edited
        setForceRender(forceRender+1);

    }
    const savefilelist = (base64Images, item, row) => {
        console.log(base64Images, 'jjdjdjjdjdj')
        let currentstate = templateContentRef.current

        currentstate.forEach((objc) => {
            if (objc.id === row) {
                objc.fields.forEach((field) => {
                    if (field.cellId === item.cellId) {
                        field.filelist = base64Images
                    }
                })
            }
        })
        // setRows(currentstate);
        templateContentRef.current=currentstate;
    }



    const renderImageUploader = (item, row) => {
        let name = item.cellId.replace("-", "");
        const handlePreview = async (file) => {
            if (!file.url && !file.preview) {
                file.preview = await getBase64(file.originFileObj);
            }
            setPreviewImage(file.url || file.preview);
            setPreviewOpen(true);
        };


        const handleFileChange = async ({ fileList }) => {

            //setFileList(fileList);
            setFileList((prevState) => ({
                ...prevState,
                [item.cellId]: fileList,
            }));

            const imagePromises = fileList.map((file, index) => {
                return new Promise((resolve) => {
                    const reader = new FileReader();
                    reader.readAsDataURL(file.originFileObj);
                    reader.onload = () => resolve({ id: index, image: reader.result }); // Get Base64 string
                });
            });

            // Wait for all images to be processed
            const base64Images = await Promise.all(imagePromises);
            savefilelist(base64Images, item, row)

        };
        const onFileRemove = (file, cellId) => {
            // if (!file || !file.uid) return;
            console.log(file, "ffffffffffff")
        }
        const uploadButton = (
            <Button type='text' icon={<PlusOutlined />} style={{ width: '100%' }}>
                Upload
            </Button>
        );

        return (
            <>
                <Form.Item style={{marginLeft:'10px',marginRight:'10px'}} name={`label${name}`} rules={[{ required: true, message: 'Please add label' }]}>
                    <Input  placeholder='Enter Description for the Uploading' onChange={(e) => { onChangeInputLabel(e, item.cellId, row) }} />
                </Form.Item>
                <Upload
                    action="https://example.com/upload"
                    listType="picture-card"
                    fileList={fileList[item.cellId]}
                    onPreview={handlePreview}
                    beforeUpload={() => false}
                    onChange={handleFileChange}
                >
                    {fileList.length >= 8 ? null : uploadButton}
                </Upload>
                {previewImage && (
                    <Image
                        wrapperStyle={{ display: 'none' }}
                        preview={{
                            visible: previewOpen,
                            onVisibleChange: (visible) => setPreviewOpen(visible),
                            afterOpenChange: (visible) => !visible && setPreviewImage(''),
                        }}
                        src={previewImage}
                    />
                )}
            </>
        );
    };
    const dropHereContent = () => {
        return <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
                height: '100%',
            }}
        >
            Drop here
        </div>
    }

    const handleDragOver = (event) => {
        event.preventDefault();
    };

    const renderRow = (row, index) => {
        const columns = [];
        const columnCount = row.type === '1' ? 1 : row.type === '2' ? 2 : 3;
        const span = 24 / columnCount;

        const fields = row.fields;

        for (let i = 0; i < columnCount; i++) {
            const cellId = `${row.id}-${i}`;

            columns.push(
                <Col
                    key={cellId}
                    span={span}
                    style={{ ...style.filterStyle }}
                    onDrop={(event) => handleDrop(event, cellId, row.id)}
                    onDragOver={handleDragOver}
                    onPointerDown={(event) => {
                        event.stopPropagation(); // Stop drag initiation
                    }}
                >
                    {fields.length !== 0 ?
                        <>
                        {(() => { 
                            let equalStatus = false;
                            let index = 0;
                            // Check if any item matches the condition
                            for (let ind = 0; ind < fields.length; ind++) {
                                if (cellId === fields[ind].cellId) {
                                    equalStatus = true;
                                    index = ind
                                    break;  // Stop loop once found
                                }
                            }

                            // Return the correct component
                            return equalStatus ? getdropcontent(fields[index], row.id) : dropHereContent();
                        })()}
                        </> :
                        <>
                            {dropHereContent()}
                        </>

                    }

                </Col>
            );
        }

        return (
            // <SortableItem
            //     key={row.id}
            //     id={row.id}
            //     onMouseEnter={() => setHoveredRowId(row.id)}
            //     onMouseLeave={() => setHoveredRowId(null)}
            // >
            <div
                key={row.id}
                id={row.id}
                // onMouseEnter={() => setHoveredRowId(row.id)}
                // onMouseLeave={() => setHoveredRowId(null)}
            >
                <Row style={{ marginBottom: '16px', position: 'relative' }}>
                    {/* {hoveredRowId === row.id && (
                        <Button
                        icon={<HolderOutlined/>}
                        type='text'
                            style={{
                                position: 'absolute',
                                right: 64, 
                                top: '50%',
                                transform: 'translateY(-50%)',
                                fontSize: 24, 
                                zIndex:99
                            }}
                        />
                    )} */}
                    {columns}
                    {/* {hoveredRowId === row.id && ( */}
                        <>
                            <Button
                                type="text"
                                icon={<DeleteOutlined />}
                                style={{
                                    position: 'absolute',
                                    right: 16,
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                }}
                                // onClick={(e) => handleDeleteRow(e,row.id,currentCellID)}
                                onClick={(event) => {
                                    //event.stopPropagation(); // Prevent drag propagation
                                    handleDeleteRow(row.id); // Handle button click
                                }}
                                onPointerDown={(event) => {
                                    event.stopPropagation(); // Stop drag initiation
                                }}
                                onMouseDown={(event) => event.stopPropagation()} // Prevent drag initiation
                                onTouchStart={(event) => event.stopPropagation()} // For touch devices
                            />

                            {/* Drag and drop holder icon added */}
                            <Button
                                name='Dragholder'
                                type="default"
                                icon={<HolderOutlined />}
                                style={{
                                    position: 'absolute',
                                    left: -16,
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    cursor: "grab"
                                }}
                            />
                        </>
                    {/* )} */}
                </Row>
            </div>
            // </SortableItem>
        );
    };

    const handleDeleteRow = (id) => {
        // console.log(formData,"onChangeInputValue in delete function");
        const regex = new RegExp(`^(${id})-`);

        console.log(regex);
        console.log(id);
        //console.log(currentCellID);
        console.log(rows, "rows in delete row function");
        console.log(droppedContent, "dropped content in delete row function");

        // Remove the row from the rows array
        const rowList = templateContentRef.current.filter(row => row.id !== id);
        console.log(rowList);

        // setRows(rowList, "row list in filterd");
        templateContentRef.current=rowList;
        //setRows((prevRows) => prevRows.filter((row) => row.id !== id));

        //setDroppedContent((droppedContent)=>Object.fromEntries( Object.entries(droppedContent).filter(([key, value]) => !regex.test(key))))
        const filteredObj = Object.fromEntries(
            Object.entries(droppedContent).filter(([key, value]) => !regex.test(key))
        );
        console.log(filteredObj, "dropped content");
        setDroppedContent(filteredObj);

        // const newState = Object.keys(formData).reduce((acc, key) => {
        //     if (!key.startsWith(`${id}-`)) { // Pattern check (attributes starting with "temp_")
        //       acc[key] = formData[key];
        //     }
        //     return acc;
        //   }, {});



        // setFormData(newState);
        //setCount(count-1);
        //setDroppedContent((droppedContent)=>Object.keys(droppedContent).filter((content)=>content.id !== currentCellID))
    };

    const handleDragEnd = (event) => {
        const { active, over } = event;

        if (!over) {
            return;
        }

        if (active.id !== over.id) {
            const oldIndex = templateContentRef.current.findIndex((row) => row.id === active.id);
            const newIndex = templateContentRef.current.findIndex((row) => row.id === over.id);
            const newItems = arrayMove(templateContentRef.current, oldIndex, newIndex);
        
            templateContentRef.current = newItems;
        }
        setForceRender(forceRender+1);
        console.log("handleDragEnd");
    };

    // const TemplateCOM=()=>{
    //     return(

    //     );
    // }

    const savetemplate = (e) => {
        settemplateName(e.target.value);
    }

    const handleChange = (newValue) => {
        console.log(newValue)
        setChangedValue(newValue);
      };
    
    const sensors = useSensors(useSensor(PointerSensor, { activationConstraint: { distance: 1 } }));
    const SortableInput = ({ row,index}) => {
        const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: row.id });
      
        const style = {
          transform: CSS.Translate.toString(transform),
          transition,
        //   padding: "10px",
        //   marginBottom: "8px",
        //   background: "#f9f9f9",
        //   borderRadius: "5px",
        //   cursor: "grab",
        //   display: "flex",
        //   alignItems: "center",
        //   gap: "10px",
        //   border: "1px solid #ddd",
        };
      
        return (
          <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
            {/* <span style={{ cursor: "grab", fontSize: "18px" }}>☰</span> Drag Handle */}
            {renderRow(row, index)}
            {/* <input
                type="text"
                // value={item.value}
                onChange={(e) => handleChange(e.target.value)}
                style={{ flex: 1, padding: "5px" }}
            /> */}
          </div>
        );
      };

    return (
        <>
            <Flex
                gap={20}
                justify="space-between"
                align="center"
                style={{
                    margin: '16px 16px 0 16px',
                    // padding: '16px 24px',
                    // background: colorBgContainer,
                    borderRadius: borderRadiusLG,
                }}
            >
                <Form layout='vertical' style={{ width: '100%' }}>

                </Form>
            </Flex>
            <div style={{ padding: '8px 16px' }}>
                <Form
                    form={form}
                    initialValues={initialValues}
                >
                    <Form.Item
                        name="templatename"
                        rules={[{ required: true, message: "Enter template name" }]}
                    >
                        <Input
                            placeholder='Template Name'
                            value={templateName}
                            onChange={(e) => { savetemplate(e) }}
                        />
                    </Form.Item>
                    <DndContext
                        sensors={sensors}
                        collisionDetection={closestCenter}
                        onDragEnd={handleDragEnd}
                    >

                        <SortableContext items={templateContentRef.current} strategy={verticalListSortingStrategy}>
                            {templateContentRef.current.map((row, index) => 
                                // renderRow(row, index)
                                <SortableInput key={index} row={row} index={index} />
                                )}
                        </SortableContext>

                    </DndContext>
                </Form>
            </div>
            <Flex
                align="center"
                justify="center"
                style={{
                    margin: '0 16px',
                    padding: '16px 24px',
                    background: colorBgContainer,
                    borderRadius: borderRadiusLG,
                }}
            >
                <Dropdown menu={{ items, onClick: handleMenuClick }}>
                    <Button type="text" size="large" icon={<PlusOutlined />} />
                </Dropdown>
            </Flex>
            <FloatButton.Group shape="square" style={{ insetInlineEnd: 16, insetBlockEnd: 56 }}>

                <Tooltip title="Title" placement="left">
                    <FloatButton
                        icon={<FontSizeOutlined />}
                        draggable
                        onDragStart={(event) => handleDragStart(event, 'Title')}
                    />
                </Tooltip>
                <Tooltip title="Text Editor" placement="left">
                    <FloatButton
                        icon={<AlignLeftOutlined />}
                        draggable
                        onDragStart={(event) => handleDragStart(event, 'TextEditor')}
                    />
                </Tooltip>
                <Tooltip title="Image Uploader" placement="left">
                    <FloatButton
                        icon={<PictureOutlined />}
                        draggable
                        onDragStart={(event) => handleDragStart(event, 'ImageUploader')}
                    />
                </Tooltip>
                <Tooltip title="Date Field" placement="left">
                    <FloatButton
                        icon={<CalendarOutlined />}
                        draggable
                        onDragStart={(event) => handleDragStart(event, 'DateField')}
                    />
                </Tooltip>
                <Tooltip title="Divider" placement="left">
                    <FloatButton
                        icon={<BorderVerticleOutlined />}
                        draggable
                        onDragStart={(event) => handleDragStart(event, 'Divider')}
                    />
                </Tooltip>
                <Tooltip title="Select Group" placement="left">
                    <FloatButton
                        icon={<PicLeftOutlined />}
                        draggable
                        onDragStart={(event) => handleDragStart(event, 'SelectGroup')}
                    />
                </Tooltip>
                <Tooltip title="Check Group" placement="left">
                    <FloatButton
                        icon={<CheckSquareOutlined />}
                        draggable
                        onDragStart={(event) => handleDragStart(event, 'CheckGroup')}
                    />
                </Tooltip>
                <Tooltip title="Radio Group" placement="left">
                    <FloatButton
                        icon={<CheckCircleOutlined />}
                        draggable
                        onDragStart={(event) => handleDragStart(event, 'RadioGroup')}
                    />
                </Tooltip>
                <Tooltip title="Signature" placement="left">
                    <FloatButton
                        icon={<HighlightOutlined />}
                        draggable
                        onDragStart={(event) => handleDragStart(event, 'Signature')}
                    />
                </Tooltip>
            </FloatButton.Group>
        </>
    );
});

const SortableItem = ({ id, children, onMouseEnter, onMouseLeave }) => {
    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
        id,
    });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
    };

    return (
        <div
            ref={setNodeRef}
            style={style}
            {...attributes}
            {...listeners}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
        >
            {children}
        </div>
    );
};

export default Templates;